import { useId } from 'react';
import {
  Button,
  Input,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@monksflow/monks-ui';
import { CopyIcon } from 'lucide-react';
import type { CustomCardProps, CustomCardWithInputProps } from './CustomCard.types';

export function CustomCard({ title, description, ariaLabel, onClick }: CustomCardProps) {
  return (
    <div className="relative w-full min-w-0 flex-1 rounded-3xl border border-border bg-card p-6">
      <div className="flex flex-col gap-3">
        <span className="text-body-lg font-medium text-foreground">{title}</span>
        <span className="text-body-lg text-muted-foreground">{description}</span>
      </div>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="icon-default"
              className="absolute top-4 right-4"
              aria-label={ariaLabel}
              onClick={() => onClick?.()}
            >
              <CopyIcon />
            </Button>
          </TooltipTrigger>
          <TooltipContent side="top">{ariaLabel}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}

export function CustomCardWithInput({
  title,
  placeholder,
  initialInputValue,
  onChange,
}: CustomCardWithInputProps) {
  const titleId = useId();

  return (
    <div className="w-full min-w-0 flex-1 overflow-hidden rounded-3xl border border-border bg-card p-6">
      <div className="flex items-center justify-between gap-4">
        <span id={titleId} className="text-body-lg font-medium text-foreground">
          {title}
        </span>
      </div>
      <div className="mt-1 flex flex-row items-center gap-2">
        <Input
          aria-labelledby={titleId}
          value={initialInputValue}
          onChange={(e) => onChange?.(e)}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
}
